import attestation1799 from '../assets/chetom/attestation1799.png';
import gravureMonteil from '../assets/chetom/gravuremonteil.jpg';
import abesseMasevaux from '../assets/chetom/abessemasevaux.png';
import abesseMasevaux2 from '../assets/chetom/abessemasevaux2.png';
import loi12Aout1792 from '../assets/chetom/loi12aout1792.png';
import loi14Juin1792 from '../assets/chetom/loi14juin1792.jpg';
import sergentAmiot from '../assets/chetom/sergentamiot.jpg';
import congePortAuPrince from '../assets/chetom/congeportauprince.png';
import societeRepublicaineToulon from '../assets/chetom/societerepublicainetoulon.png';
import reglement29Sept1693 from '../assets/chetom/reglement29sept1693.jpg';

export const archives = [
    {
        id: 1,
        title: "Attestation du directeur d’Artillerie de Marine en Italie le 15 avril 1799",
        date: "15 Avril 1799",
        image: attestation1799,
    },
    {
        id: 2,
        title: "Gravure de MONTEIL",
        date: "Date inconnue",
        image: gravureMonteil,
    },
    {
        id: 3,
        title: "Lettre de l'Abesse de Masevaux à Monseigneur",
        date: "10 février 1790",
        image: abesseMasevaux,
    },
    {
        id: 4,
        title: "Lettre de l'Abesse de Masevaux à Monseigneur",
        date: "10 février 1790",
        image: abesseMasevaux2,
    },
    {
        id: 5,
        title: "Loi du 12 août 1792 - Sous Lieutenants de Marine",
        date: "12 août 1792",
        image: loi12Aout1792,
    },
    {
        id: 6,
        title: "Loi du 14 juin 1792",
        date: "14 juin 1792",
        image: loi14Juin1792,
    },
    {
        id: 7,
        title: "Ordre de mission du Sergent Amiot - 1840",
        date: "9 novembre 1840",
        image: sergentAmiot,
    },
    {
        id: 8,
        title: "Saint Domingue, 1791 - Régiment du Port au Prince - Infanterie - Congé",
        date: "29 décembre 1791",
        image: congePortAuPrince,
    },
    {
        id: 9,
        title: "Société Républicaine de Toulon",
        date: "26 décembre 1792",
        image: societeRepublicaineToulon,
    },
    {
        id: 10,
        title: "Réglement du 29 septembre 1693",
        date: "29 septembre 1693",
        image: reglement29Sept1693,
    }
];
